// Constants for Invitation - Internal (Panitia Lelang).
//
// The internal (committee-facing) side of the invitation to the tender-opening
// session. The logged-in panitia member sees the invitations addressed to them
// and Confirms attendance — either attending in person (Present) or sending a
// delegate (Delegate, with the delegate's name + email). Everything on the
// Detail page is view-only except the single Confirm action.
//
// TODO(API): no backend contract exists for this screen yet. The module runs on
// the in-memory store in invitationInternalStore.js behind the
// invitationInternalApi.js facade — swapping to live endpoints is confined to
// that one file. Enum spellings below are the values expected on the wire (C#
// member names, as elsewhere in the project), NOT display labels.

// Invitation status for the logged-in panitia member. Only two states (DOD): a
// pending invite (Open) and a confirmed one (Confirmed). Confirmed is terminal.
export const INVITATION_STATUS = {
  OPEN: 'Open',
  CONFIRMED: 'Confirmed',
};

export const INVITATION_STATUS_BADGE = {
  [INVITATION_STATUS.OPEN]: 'warning',
  [INVITATION_STATUS.CONFIRMED]: 'success',
};

// Confirm is offered only while the invitation is still Open.
export const canConfirm = status => status === INVITATION_STATUS.OPEN;

// Participation mode chosen in the Confirm popup. Present = attend in person (no
// extra data); Delegate = send someone else, whose name + email are captured.
export const PARTICIPATION = {
  PRESENT: 'Present',
  DELEGATE: 'Delegate',
};

// Document source labels — internal sees documents from BOTH upstream stages
// (Planning and Procurement); unlike the external/DMUT view there is no
// showToDmut filter here (the committee sees everything).
export const DOC_SOURCE = {
  PLANNING: 'Planning',
  PROCUREMENT: 'Procurement',
};

export const DOC_SOURCE_BADGE = {
  [DOC_SOURCE.PLANNING]: 'info',
  [DOC_SOURCE.PROCUREMENT]: 'primary',
};

// Keyword search covers Title, Id Procurement and Description only (DOD item 2).
export const SEARCHABLE_FIELDS = ['procId', 'title', 'description'];

// Sortable columns — every column except Action (DOD item 6).
export const SORTABLE_FIELDS = [
  'procId',
  'title',
  'procurementType',
  'procurementMethod',
  'description',
  'invitationStatus',
];

export const DEFAULT_PAGE_SIZE = 10; // DOD item 4

// Simple RFC-5322-lite email check for the Delegate form.
export const isValidEmail = value =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
